import { render, staticRenderFns } from "./shippingForm.vue?vue&type=template&id=65f1547e&"
import script from "./shippingForm.vue?vue&type=script&lang=js&"
export * from "./shippingForm.vue?vue&type=script&lang=js&"
import style0 from "./shippingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f1547e')) {
      api.createRecord('65f1547e', component.options)
    } else {
      api.reload('65f1547e', component.options)
    }
    module.hot.accept("./shippingForm.vue?vue&type=template&id=65f1547e&", function () {
      api.rerender('65f1547e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/shippingForm.vue"
export default component.exports